import React from 'react'
import { get, post, put } from 'client/utils/api-routes.util'
import {
  DcButton,
  DcDropDown,
  DcInput,
  DcInputTag,
  DcSwitch,
  PixelCheckboxGroup,
  PixelFactoryContext,
  PixelText,
  SectionHeader,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../../../decl.d'

export interface IZoneTemplate {
  id: number
  zone_name: string
  cities: [
    {
      id: number
      name: string
      state_province: string
      country: string
      post_code: string
    },
  ]
}

const AddNewZone = (props) => {
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const { handleClose, zone, zoneID, cities } = props

  const [data, setData] = React.useState<any>({
    zone_id: '',
    is_all_cities: true,
    is_active: null,
    is_default: null,
    is_template: null,
    include_cities: [],
    exclude_cities: [],
    zone_template_cities: [],
  })
  const [options, setOptions] = React.useState<string>('All Cities')
  const [zonetemplate, setZoneTemplate] = React.useState<IZoneTemplate[]>([])
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const readData = () => {
    get('/location/zones-template').subscribe(
      (res: AjaxResponse<IZoneTemplate | any>) => {
        const zone = res.response.data as IZoneTemplate
        setZoneTemplate(zone)
      },
    )
  }
  React.useEffect(() => {
    readData()
  }, [])

  React.useEffect(() => {
    if (zoneID !== null) {
      setData({
        zone_name: zone.zone_name,
        is_all_cities: zone.is_all_cities,
        include_cities: zone.include_cities?.map((city: any) => `${city.id}`),
        exclude_cities: zone.exclude_cities?.map((city: any) => `${city.id}`),
        is_active: zone.is_active,
        is_default: zone.is_default,
      })
    } else {
      setData({
        zone_name: '',
        is_all_cities: true,
        is_active: null,
        is_default: null,
        include_cities: [],
        exclude_cities: [],
        zone_template_cities: [],
      })
    }
  }, [zoneID])
  const handleUpdateZone = (zone_id) => {
    showPageLoader()
    const UpdatedZoneData = {
      zone_name: data.zone_name,
      is_all_cities: data.is_all_cities,
      include_cities:
        options === 'Zone Template'
          ? data.zone_template_cities
          : !['Included Cities', 'Zone Template'].includes(options)
          ? []
          : data.include_cities,
      exclude_cities: options != 'All Cities' ? [] : data.exclude_cities,
      is_active: data.is_active,
      is_default: data.is_default,
    }
    put(`/location/zones/${zone_id}`, UpdatedZoneData).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Zone updated successfully')
        handleClose(res.response.data, 'update')
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure('Something went wrong')
        }
        hidePageLoader()
      }
    })
  }
  const handleAddZone = () => {
    showPageLoader()
    const AddZoneData = {
      zone_name: data.zone_name,
      is_all_cities: data.is_all_cities,
      include_cities:
        options === 'Zone Template'
          ? data.zone_template_cities
          : !['Included Cities', 'Zone Template'].includes(options)
          ? []
          : data.include_cities,

      exclude_cities: options != 'All Cities' ? [] : data.exclude_cities,
    }
    post('/location/zones', AddZoneData).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Added')
        handleClose(res.response.data, 'add')
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure('Something went wrong')
        }
        hidePageLoader()
      }
    })
  }

  return (
    <>
      <Form>
        <FormGroup>
          <FilterInput>
            <DcInput
              error={
                error.field === 'zone_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Title'}
              placeholder={'Zone Name'}
              value={data.zone_name}
              onChange={(e) => setData({ ...data, zone_name: e.target.value })}
            />
          </FilterInput>
        </FormGroup>
        <FormGroup>
          <PixelCheckboxGroup
            options={[
              {
                label: 'All Cities',
                value: 'All Cities',
                type: 'radio',
                checked: options === 'All Cities',
              },
              {
                label: 'Included Cities',
                value: 'Included Cities',
                type: 'radio',
                checked: options === 'Included Cities',
              },
              {
                label: 'Zone Template',
                value: 'Zone Template',
                type: 'radio',
                checked: options === 'Zone Template',
              },
            ]}
            onChange={(e) => {
              setOptions(e.target.value)
            }}
          />
        </FormGroup>
        <FormGroup>
          <FilterInput>
            {options == 'Zone Template' ? (
              <>
                <DcDropDown
                  error={
                    error.field === 'zone_name' && error.error !== ''
                      ? error.error
                      : null
                  }
                  required
                  name={'Title'}
                  placeholder={'Select Zone Name'}
                  options={[...zonetemplate].map((item) => {
                    return {
                      label: `${item.zone_name} (All Cities Of ${item.zone_name})`,
                      value: item.id,
                    }
                  })}
                  value={data.zone_id}
                  onChange={(e) => {
                    const selectedZone = zonetemplate.find(
                      (zone) => zone.id === e.target.value,
                    )

                    if (selectedZone) {
                      const includedCities = selectedZone.cities.map(
                        (city) => city.id,
                      )

                      setData({
                        ...data,
                        zone_id: e.target.value,
                        is_all_cities: false,
                        zone_template_cities: includedCities,
                      })
                    }
                  }}
                />
              </>
            ) : (
              <>
                {options == 'Included Cities' && (
                  <DcInputTag
                    allowCustomTags={false}
                    // inputLabel={'Include Cities'}
                    placeholder="Select City"
                    handleTagDelete={(e) => {
                      setData({
                        ...data,
                        include_cities: data.include_cities.filter(
                          (city: any) => city !== e.value,
                        ),
                      })
                    }}
                    options={props.cities}
                    clearAll={() => {
                      setData({
                        ...data,
                        include_cities: [],
                      })
                    }}
                    handleTagAdd={(e) => {
                      setData({
                        ...data,
                        is_all_cities: false,
                        include_cities: [...data.include_cities, e.value],
                      })
                    }}
                    tags={data.include_cities?.map((item) => {
                      return {
                        label:
                          cities.find((city) => city.value === item)?.label ||
                          item,
                        value: item,
                      }
                    })}
                  />
                )}
                {options == 'All Cities' && (
                  <DcInputTag
                    // inputLabel={'Exclude Cities'}
                    allowCustomTags={false}
                    placeholder="Select City"
                    options={props.cities}
                    handleTagDelete={(e) => {
                      setData({
                        ...data,
                        exclude_cities: data.exclude_cities.filter(
                          (city: any) => city !== e.value,
                        ),
                      })
                    }}
                    clearAll={() => {
                      setData({
                        ...data,
                        exclude_cities: [],
                      })
                    }}
                    handleTagAdd={(e) => {
                      setData({
                        ...data,
                        is_all_cities: true,
                        exclude_cities: [...data.exclude_cities, e.value],
                      })
                    }}
                    tags={data.exclude_cities?.map((item) => {
                      return {
                        label:
                          props.cities.find((city) => city.value === item)
                            ?.label || item,
                        value: item,
                      }
                    })}
                  />
                )}
              </>
            )}
          </FilterInput>
        </FormGroup>
        {zoneID !== null && (
          <>
            <FormGroup>
              <SectionHeader style={{ width: '100%', marginBottom: '0px' }}>
                <PixelText>Active Zone</PixelText>
                <DcSwitch
                  onChange={(e) => {
                    setData({ ...data, is_active: e.target.checked })
                  }}
                  label={data.is_active === true ? 'Yes' : ' No'}
                  checked={data.is_active}
                />
              </SectionHeader>
            </FormGroup>
            <FormGroup>
              <SectionHeader style={{ width: '100%', marginBottom: '0px' }}>
                <PixelCheckboxGroup
                  options={[
                    {
                      label: 'Make it default',
                      value: true,
                      type: 'checkbox',
                      checked: data.is_default === true,
                    },
                  ]}
                  onChange={(e) => {
                    setData({ ...data, is_default: e.target.checked })
                  }}
                />
              </SectionHeader>
            </FormGroup>
          </>
        )}

        <FormGroup flexEnd>
          <DcButton
            size="sm"
            onClick={() => {
              handleClose()
            }}
            variant="outline-secondary"
          >
            Close
          </DcButton>
          <DcButton
            size="sm"
            variant="primary"
            onClick={() => {
              if (zoneID) {
                handleUpdateZone(zoneID)
              } else {
                handleAddZone()
              }
            }}
          >
            {zoneID ? 'Update' : 'Add'}
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const FilterInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`
export default AddNewZone
